import BaseBankLogo, { BaseBankLogoProps, BankLogoConfig } from './BaseBankLogo';

type TdLogoProps = Omit<BaseBankLogoProps, 'config' | 'renderLogo'>;

const tdConfig: BankLogoConfig = {
    colors: {
        background: '#54B948',
        logo: 'white',
    },
    defaultAlt: 'TD Bank Logo',
};

const renderTdLogo = (colors: { background: string; border?: string; logo: string }) => (
    <path
        d="M40.1232 45.2314H28.2456V23.9226H34.2114V41.4568H39.9492C43.9101 41.4568 45.5739 38.7242 45.5739 31.6872C45.5739 24.608 43.6838 22.5508 39.6629 22.5508H26.5768V45.2314H20.6692V22.5508H12V18.7678H41.5032C48.6193 18.7678 52 22.4348 52 31.6308C52 43.7461 46.9522 45.2314 40.1232 45.2314Z"
        fill={colors.logo}
    />
);

/**
 * TD Bank logo component with flexible sizing and color variants
 */
function TdLogo(props: TdLogoProps) {
    return <BaseBankLogo {...props} config={tdConfig} renderLogo={renderTdLogo} />;
}

export default TdLogo;
